/* Free-shipping progress bar — Montena.
   Mantiene viva la barra superior sticky (fuera de las secciones del carrito).
   El cajón y la página del carrito ya se re-renderizan solos vía Section Rendering. */
if (!customElements.get('free-shipping-bar')) {
  class FreeShippingBar extends HTMLElement {
    connectedCallback() {
      this.threshold = parseInt(this.dataset.threshold, 10) || 3900;
      // El servidor ya renderiza el ancho correcto en línea; el JS solo
      // mantiene viva la barra superior cuando cambia el carrito sin recargar.
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
      }
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
    }

    async refresh() {
      try {
        const base = (window.routes && window.routes.cart_url) || '/cart';
        const res = await fetch(`${base}.js`, { headers: { Accept: 'application/json' } });
        if (!res.ok) return;
        const cart = await res.json();
        this.render(cart.total_price);
      } catch (e) {
        /* silencioso: si falla, la barra mantiene su último estado */
      }
    }

    render(total) {
      const remaining = this.threshold - total;
      const pct = total > 0 ? Math.min(100, Math.round((total * 100) / this.threshold)) : 0;
      const reached = remaining <= 0;

      const fill = this.querySelector('.fsb__fill');
      const track = this.querySelector('.fsb__track');
      const msg = this.querySelector('.fsb__msg');

      if (fill) fill.style.width = pct + '%';
      if (track) track.setAttribute('aria-valuenow', pct);
      this.classList.toggle('fsb--reached', reached);

      if (msg) {
        msg.innerHTML = reached
          ? '🎉 ¡Enhorabuena! Tienes <strong>envío GRATIS</strong>'
          : 'Te faltan <strong class="fsb__amount">' +
            this.formatMoney(remaining) +
            '</strong> para el <strong>envío GRATIS</strong> 🚚';
      }
    }

    formatMoney(cents) {
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }
  }

  customElements.define('free-shipping-bar', FreeShippingBar);
}
